import type { SaveStatus } from '@/contexts/SaveStatusContext'
import { SaveStatusIndicator } from '@/components/toolbar/SaveStatusIndicator'
import { SidebarToggleButton } from './SidebarToggleButton'

interface ToolbarFooterProps {
	showPanel?: boolean
	onTogglePanel?: () => void
	saveStatus?: SaveStatus
}

/**
 * Shared footer section for editor toolbars: separator + sidebar toggle + save status.
 */
export function ToolbarFooter({ showPanel, onTogglePanel, saveStatus }: ToolbarFooterProps) {
	const hasToggle = onTogglePanel !== undefined

	return (
		<>
			{hasToggle && (
				<>
					<div className="toolbar-separator" />
					<SidebarToggleButton
						isVisible={showPanel ?? false}
						onToggle={onTogglePanel!}
					/>
				</>
			)}

			{saveStatus && (
				<>
					{!hasToggle && <div className="toolbar-separator" />}
					<SaveStatusIndicator status={saveStatus} />
				</>
			)}
		</>
	)
}
